export const IMAGES = {
  heroAbstract:
    "https://static.prod-images.emergentagent.com/jobs/22af70ac-a7f8-4d15-af58-11606906b37a/images/969c59ea61008a269bdd25196dde0ecc029c0e14ad88c3bfa788da45872d81ad.jpeg",
  teamDesigner:
    "https://static.prod-images.emergentagent.com/jobs/22af70ac-a7f8-4d15-af58-11606906b37a/images/7a31d6f3ac90bcf5563bc0945d4708698bfe421e7fd8f30e1600a573f27ed5ee.jpeg",
  teamStrategist:
    "https://static.prod-images.emergentagent.com/jobs/22af70ac-a7f8-4d15-af58-11606906b37a/images/c514032cb06ca3f0e84c06df225737b7ff3e91cbd4d7d778641b5386f35f5245.jpeg",
  work1:
    "https://images.unsplash.com/photo-1558259299-5d46c4408730?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  work2:
    "https://images.unsplash.com/photo-1620325867502-221cfb5faa5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  work3:
    "https://static.prod-images.emergentagent.com/jobs/22af70ac-a7f8-4d15-af58-11606906b37a/images/e3f0c6157c6c793676f5c229e5497d6eabaf86cc0b2c0b47a5971c20e8142182.jpeg",
  work4:
    "https://images.unsplash.com/photo-1595039838779-f3780873afdd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  work5:
    "https://images.unsplash.com/photo-1585791022456-be89ddf09c75?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  videoProd:
    "https://images.unsplash.com/photo-1580707221190-bd94d9087b7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  offer:
    "https://static.prod-images.emergentagent.com/jobs/22af70ac-a7f8-4d15-af58-11606906b37a/images/3be63e98a1e6dac68ade26a2c5752fefab8e5ecff098bdcdaa3e9723454296b3.jpeg",
};

export const NAV_LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Vídeo", href: "#video" },
  { label: "Proyectos", href: "#proyectos" },
  { label: "Equipo", href: "#equipo" },
  { label: "Cita", href: "#cita" },
];

export const CONTACT = {
  whatsapp: "https://wa.me/34634747862",
  whatsappLabel: "+34 634 747 862",
  email: "hola@isavicente.com",
  instagram: "https://instagram.com/isavicentecm",
  instagramLabel: "@isavicentecm",
  linkedin: "https://linkedin.com/in/isavicente",
  tiktok: "https://tiktok.com/@isavicente",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Escuchamos",
    text: "Analizamos tu marca, tu sector y a tu audiencia. Antes de crear, entendemos qué te hace único y dónde está tu oportunidad real de crecer.",
  },
  {
    n: "02",
    title: "Creamos",
    text: "Diseñamos una estrategia a medida: contenido, identidad visual y web. Todo bajo una narrativa coherente que conecta y convierte.",
  },
  {
    n: "03",
    title: "Crecemos",
    text: "Ejecutamos, medimos y optimizamos cada mes. Convertimos seguidores en comunidad y comunidad en clientes fieles.",
  },
];

export const SERVICES = [
  {
    icon: "MessageCircle",
    title: "Community Management",
    text: "Gestión integral de tus redes sociales: contenido estratégico, calendario editorial y una comunidad fiel enamorada de tu marca.",
    tag: "Redes Sociales",
  },
  {
    icon: "MonitorSmartphone",
    title: "Diseño de Páginas Web",
    text: "Webs frescas, rápidas y hechas para vender. Diseño a medida que transmite confianza y convierte visitas en clientes.",
    tag: "Desarrollo Web",
  },
  {
    icon: "PenTool",
    title: "Diseño Gráfico",
    text: "Identidad visual con carácter. Logos, branding y creatividades que hacen que tu marca destaque en cualquier plataforma.",
    tag: "Branding",
  },
  {
    icon: "TrendingUp",
    title: "Estrategia de Marketing",
    text: "Planes de marketing digital con foco en resultados. Definimos objetivos, audiencia y acciones que impulsan tu negocio.",
    tag: "Marketing",
  },
];

export const STATS = [
  { value: "+120", label: "Marcas impulsadas" },
  { value: "+8M", label: "Alcance generado" },
  { value: "4.9", label: "Valoración media" },
  { value: "100%", label: "Dedicación fresca" },
];

export const TEAM = [
  {
    role: "La Diseñadora",
    focus: "Diseño Gráfico & Identidad Visual",
    text: "Convierte ideas en imágenes memorables. Cada pixel tiene intención.",
    image: IMAGES.teamDesigner,
  },
  {
    role: "La Estratega",
    focus: "Marketing & Growth",
    text: "Traduce datos en decisiones. La brújula que marca el rumbo de cada campaña.",
    image: IMAGES.teamStrategist,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Nuestra comunidad creció como nunca. En dos meses pasamos de publicar por publicar a tener una estrategia real.",
    author: "Laura M.",
    company: "Tienda de cosmética natural",
  },
  {
    quote:
      "La web que nos hicieron es una pasada. Fresca, rápida y por fin nos llegan clientes desde ahí.",
    author: "Carlos R.",
    company: "Estudio de arquitectura",
  },
  {
    quote:
      "isavicente entendió nuestra marca mejor que nosotros mismos. El branding es justo lo que soñábamos.",
    author: "Nerea G.",
    company: "Marca de moda sostenible",
  },
  {
    quote:
      "Profesionales, cercanas y con un gusto brutal. Los resultados hablan por sí solos.",
    author: "David P.",
    company: "Restaurante de autor",
  },
];

export const MARQUEE_WORDS = [
  "CREATIVIDAD",
  "ESTRATEGIA",
  "DISEÑO",
  "RESULTADOS",
  "COMUNIDAD",
  "FRESCURA",
];

export const SOCIAL_PROJECTS = [
  {
    image:
      "https://images.unsplash.com/photo-1645848949816-686bca41518e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Feed editorial para marca lifestyle",
    network: "Instagram",
    handle: "@lifestyle.brand",
  },
  {
    image:
      "https://images.unsplash.com/photo-1670757781705-9b6cb1ad0ca6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Contenido gastronómico que abre el apetito",
    network: "Instagram",
    handle: "@sabores.demarca",
  },
  {
    image:
      "https://images.unsplash.com/photo-1555545624-16240401df02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Campaña de producto para e-commerce",
    network: "LinkedIn",
    handle: "isavicente studio",
  },
  {
    image:
      "https://images.unsplash.com/photo-1670508183158-d1a3cbf5239a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Reels de recetas para restaurante",
    network: "TikTok",
    handle: "@cocina.viva",
  },
  {
    image:
      "https://images.unsplash.com/photo-1675001849511-509a2351ff69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Branding visual para marca de moda",
    network: "Instagram",
    handle: "@moda.sostenible",
  },
  {
    image:
      "https://images.unsplash.com/photo-1627807353949-fb35760dd16b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Storytelling de marca personal",
    network: "LinkedIn",
    handle: "isavicente",
  },
];

